/* unplugin-vue-components disabled */import { render } from "./pointlist.vue?vue&type=template&id=5424e9f1&scoped=true"
import script from "./pointlist.vue?vue&type=script&lang=js"
export * from "./pointlist.vue?vue&type=script&lang=js"

import "./pointlist.vue?vue&type=style&index=0&id=5424e9f1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5424e9f1"]])

export default __exports__